import { setSyncedProduct } from "action/utils/setSyncedProduct";
import classNames from "classnames";
import { useDispatch } from "react-redux";
import HideIf from "util/HideIf";
import { createElement } from "react";
import styles from "./styles.module.scss";

function ProductQuantity(props: any) {
  const {
    onChange, limitedQuantityDetails = { limitedQuantity: false, quantity: 0 }, outOfStock = false, className = "",
    setQuantityState, productQuantity, setSyncProduct, sku, onlyIcon = false, availableQuantity,
  } = props;

  const dispatch = useDispatch();

  const { limitedQuantity, quantity } = limitedQuantityDetails;

  const disabledIncreaseButton = outOfStock || (limitedQuantity && quantity <= productQuantity) || (availableQuantity && productQuantity >= availableQuantity);
  const disabledDecreaseButton = outOfStock || productQuantity <= 1;
  const component = onlyIcon ? "i" : "button";

  function setQuantity(newQuantity?: number) {
    if (!newQuantity) {
      setQuantityState();
    } else {
      const finalQuantity = newQuantity < 1 ? 1 : newQuantity;
      setQuantityState(finalQuantity);
      if (setSyncProduct) {
        dispatch(setSyncedProduct({
          sku,
          quantity: finalQuantity,
        }));
      }
      if (onChange) {
        onChange(finalQuantity);
      }
    }
  }

  function onBlur() {
    if (!productQuantity) {
      setQuantity(1);
    }
  }

  function handleSetQuantity(event: any) {
    let newQuantity = 1;
    const radix = 10;
    if (event.target.value) {
      try {
        if (!isNaN(event.target.value)) {
          newQuantity = parseInt(event.target.value, radix);
          newQuantity = newQuantity < 1 ? 1 : newQuantity;
          if (limitedQuantity && newQuantity > quantity) newQuantity = quantity;
        }
      } catch (__err) {
        newQuantity = 1;
      }
      setQuantity(newQuantity);
    } else {
      setQuantity();
    }
  }

  function handleDecreaseQuantity() {
    if (!disabledDecreaseButton) {
      setQuantity(productQuantity - 1);
    }
  }

  function handleIncreaseQuantity() {
    if (!disabledIncreaseButton) {
      setQuantity(productQuantity + 1);
    }
  }

  return (
    <div className={`d-flex align-items-center ${styles.rowSection} ${styles.product_qty} ${className}`}>
      {createElement(
        component,
        {
          className: classNames(`${styles.btn} ${styles.left_btn}`, {
            fa: onlyIcon,
            "fa-minus-square-o": onlyIcon,
            [styles.only_icon]: onlyIcon,
            [styles.disabled_icon]: disabledDecreaseButton && onlyIcon,
            [styles.enabled_icon]: !disabledDecreaseButton && onlyIcon,
          }),
          disabled: disabledDecreaseButton,
          onClick: handleDecreaseQuantity,
          type: "button",
        },
        <HideIf show={!onlyIcon}>
          <span data-testid="decrease-qty"> - </span>
        </HideIf>,
      )}

      <label htmlFor={`quantity-input-${sku}`} className="hidden m-0" />
      <input
        data-testid="quantity-input"
        type="text"
        aria-label="quantity-input"
        id={`quantity-input-${sku}`}
        inputMode="numeric"
        className={`btn btn-default ${styles.input}`}
        value={productQuantity}
        disabled={outOfStock}
        onChange={handleSetQuantity}
        onBlur={onBlur}
      />

      {createElement(
        component,
        {
          className: classNames(`${styles.btn} ${styles.right_btn}`, {
            fa: onlyIcon,
            "fa-plus-square-o": onlyIcon,
            [styles.only_icon]: onlyIcon,
            [styles.disabled_icon]: disabledIncreaseButton && onlyIcon,
            [styles.enabled_icon]: !disabledIncreaseButton && onlyIcon,
          }),
          disabled: disabledIncreaseButton,
          onClick: handleIncreaseQuantity,
          type: "button",
        },
        <HideIf show={!onlyIcon}>
          <span data-testid="increase-qty"> + </span>
        </HideIf>,
      )}
    </div>
  );
}

export default ProductQuantity;
